import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {API} from "../../../../config";
import Profile from "./profile";
import Statements from "./statements";
import Trading from "./trading";
import KYCDocs from "./kyc_docs";
import OtherDocs from "./other_docs";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Comms from "./comms";
import {connect} from "react-redux";
import Notes from "../../kyc/components/notes";
const investor = API.service('investors');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    detail:{
        height:'100%',
        overflow:'auto'
    },
    detailContent:{
        margin:'8px 0',
        paddingTop:'10px'
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },

});

class InvestorView extends Component {
    state={
        activeTab:'profile',
        investor:false,
    }

    closeDetails = () => {
        this.props.context.update({
            drawerContent:false,
            drawerWidth:null
        })
    }

    componentDidMount() {
        this.loadInvestor(this.props.context.selectedInvestor);
    }

    loadInvestor = () => {
        if(this.props.investor !== 'new') {
            investor.find({query: {_id:this.props.investor._id,incl: 'compliance'}}).then(i => {
                console.log(i);
                this.setState({
                    investor: i.data[0]
                })
            })

            return true
        } else {
            this.setState({
                investor: 'new'
            })

            return true
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            this.loadInvestor()
        }
    }

    changeTab = (e) => {
        this.setState({
            activeTab:e.target.id
        })
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.detail + ' flex flex-col'} style={{height:'100vh'}}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.flex}>
                            <Typography variant="title" color="inherit">
                                {this.props.investor._surname}, {this.props.investor._firstname}
                            </Typography>
                            <Typography variant="subheading" color="inherit">
                                {this.props.investor.acc}
                            </Typography>
                        </div>
                        <Button onClick={this.closeDetails} color={'inherit'}><FontAwesomeIcon icon="times" size="2x" /></Button>
                    </Toolbar>
                </AppBar>

                    <div style={{padding:20,paddingBottom:0,paddingTop:0}}>
                        <div className={classes.detailContent}>
                            <ul className={classes.tabs}>
                                <li>
                                    <button className={(this.state.activeTab === 'profile') ? 'active' : ''} onClick={this.changeTab} id={'profile'}>Profile</button>
                                </li>
                                {(this.props.investor !== 'new') &&
                                    <React.Fragment>
                                        {(this.props.user.role.includes('super') || this.props.user.role.includes('comms')) &&
                                            <li>
                                                <button className={(this.state.activeTab === 'comms') ? 'active' : ''}
                                                        onClick={this.changeTab} id={'comms'}>Communications
                                                </button>
                                            </li>
                                        }
                                        <li>
                                            <button className={(this.state.activeTab === 'finance') ? 'active' : ''}
                                                    onClick={this.changeTab} id={'finance'}>Finances
                                            </button>
                                        </li>
                                        <li>
                                            <button className={(this.state.activeTab === 'trading') ? 'active' : ''}
                                                    onClick={this.changeTab} id={'trading'}>Trading
                                            </button>
                                        </li>
                                        <li>
                                            <button className={(this.state.activeTab === 'kyc') ? 'active' : ''}
                                                    onClick={this.changeTab} id={'kyc'}>KYC Documents
                                            </button>
                                        </li>
                                        <li>
                                            <button className={(this.state.activeTab === 'docs') ? 'active' : ''}
                                                    onClick={this.changeTab} id={'docs'}>Other Documents
                                            </button>
                                        </li>
                                        <li>
                                            <button className={(this.state.activeTab === 'notes') ? 'active' : ''}
                                                    onClick={this.changeTab} id={'notes'}>Notes
                                            </button>
                                        </li>
                                    </React.Fragment>
                                }
                                {/*<li>
                                    <button className={(this.state.activeTab === 'notes') ? 'active' : ''} onClick={this.changeTab} id={'notes'}>Notes</button>
                                </li>*/}
                            </ul>
                        </div>
                    </div>
                    <div className={'flex-1'} style={{overflow:'auto',padding:20,paddingTop:0}}>
                        {(this.state.activeTab === 'profile' && this.state.investor) &&
                            <Profile investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'comms' && this.state.investor) &&
                        <Comms investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'finance' && this.props.investor !== 'new') &&
                            <Statements investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'trading' && this.props.investor !== 'new') &&
                            <Trading investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'kyc' && this.props.investor !== 'new') &&
                            <KYCDocs investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'docs' && this.props.investor !== 'new') &&
                            <OtherDocs investor={this.state.investor} />
                        }
                        {(this.state.activeTab === 'notes' && this.props.investor !== 'new') &&
                        <Notes investor={this.state.investor} />
                        }
                    </div>
            </div>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter((connect(mapStateToProps)(InvestorView)))));
